import { Box, Card, CardContent, Grid } from '@mui/material';
import { WsButtonGroup, WsTypography } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';

const NotificationSettingsPage = () => {
  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_NOTIFICATION_SETTINGS,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  const optionsList = [
    { label: 'Notify me when there is a new submission to a job I own(job admin)', value: 0 },
    {
      label:
        'Notify me when there is a change in stage/state to the submission I own(job admin) or I have done',
      value: 0,
    },
    {
      label: 'Notify me when notes are added to the submission I own(job admin) or I have done',
      value: 0,
    },
    {
      label:
        'Notify me when a candidate applies to the job I own or publish on external job boards',
      value: 0,
    },
    {
      label: 'Notify me on closing a job which I own or assigned',
      value: 0,
    },
    {
      label: 'Notify me when a Job is assigned or shared with me',
      value: 0,
    },
    {
      label: 'Notify me on task overdue',
      value: 0,
    },
  ];
  return (
    <Card sx={{ minHeight: '28vw', width: '100%' }}>
      <CardContent>
        <Box component="form" px={8} pt={2}>
          {!manageAccess && (
            <Grid container direction={'column'} wrap="nowrap" spacing={3}>
              {optionsList.map((e) => (
                <Grid item key={e.label}>
                  <WsTypography>{e.label}</WsTypography>
                </Grid>
              ))}
            </Grid>
          )}
          {manageAccess && (
            <Grid container direction={'column'} wrap="nowrap" spacing={3}>
              {optionsList.map((e) => (
                <Grid item key={e.label}>
                  <WsButtonGroup
                    inputTitle={e.label}
                    buttonsList={['Allow on App', 'Allow on Desktop and App', "Don't Notify"]}
                    defaultValue={e.value}
                    selectedIndexValue={(i, v) => {
                      switch (i) {
                        case 0:
                          console.log(`${v}=1`);
                          break;
                        case 1:
                          console.log(`${v}=2`);
                          break;
                        case 2:
                          console.log(`${v}=3`);
                          break;
                      }
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default NotificationSettingsPage;
